import { Page, Layout, Card, Text, BlockStack, Button } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks";
import { openCartDrawer } from "features/document-cart/documentCart.slice";

/**
 * Full-page cart entry — opens the same drawer UX and links to history.
 */
const DocumentCartPage: React.FC = () => {
  const { t } = useTranslation();
  const { companyId } = useParams<{ companyId: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const session = useAppSelector((s) => s.authReducer.session);

  return (
    <Page
      fullWidth
      title={t("document_cart")}
      backAction={
        companyId
          ? { onAction: () => navigate(`/app/${companyId}/documents`) }
          : undefined
      }
    >
      <Layout>
        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="p">{t("document_cart_page_hint")}</Text>
              <BlockStack gap="200">
                <Button
                  variant="primary"
                  onClick={() => dispatch(openCartDrawer())}
                >
                  {t("document_cart_open")}
                </Button>
                {companyId && session?.id && (
                  <Button
                    onClick={() =>
                      navigate(
                        `/app/${companyId}/profile/${session.id}/downloads`
                      )
                    }
                  >
                    {t("document_cart_view_history")}
                  </Button>
                )}
              </BlockStack>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default DocumentCartPage;
